import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/auth';

let envs = {
  apiKey: process.env.REACT_APP_FIREBASE_PUBLIC_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
};

const firebaseApp = firebase.initializeApp(envs);

const db = firebaseApp.firestore();
const storage = firebaseApp.storage();
const auth = firebaseApp.auth();

// Garante que a sessão Firebase persista ao recarregar a página
auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL)
  .catch((error) => {
    console.error('Erro ao configurar persistência Firebase:', error);
  });

// Instância secundária usada para autenticar credenciais de Vale Viagem
// sem trocar a sessão do usuário autenticado (Fluxo 2 — RN020/CA016).
const getVoucherAuth = () => {
  const existing = firebase.apps.find((app) => app.name === 'voucher-auth');
  const voucherApp = existing || firebase.initializeApp(envs, 'voucher-auth');
  return voucherApp.auth();
};

export { db, storage, auth, getVoucherAuth };
